export default "__VITE_ASSET__BztgR2uj__"